// extracted by mini-css-extract-plugin
module.exports = {"postSection":"style_postSection__QJc4q","paths":"style_paths__h3PyK","postWrapper":"style_postWrapper__VCjjO"};